/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState, useRef, useEffect} from "react";
import {Box, Typography, Grid, TextField, Button, Input, Container, Backdrop, Fade, Modal} from "@material-ui/core";
import {colorWhite} from "../../../Constants/theme";
import {makeStyles, Theme} from "@material-ui/core/styles";
import {useSnackbar} from "notistack";

// background-color: #ffffff;
// opacity: 1;
// position: fixed;

//Styles:
const useStyle = makeStyles((theme: Theme) => ({
    container: {
        marginTop: "10px",
        bgcolor: "#ffffff",
        position: "fixed",
        width: "95%",
        marginBottom: "0px",
        bottom: "10px"
    },
    modal: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        [theme.breakpoints.down("sm")]: {
            width: "99%",
            margin: "0 auto"
        }
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 2),
        display: "flex",
        flexDirection: "column"
    },
    button: {
        width: 110,
        marginTop: 10,
        marginBottom: 10
    }
}));

const vetStyle = makeStyles((theme: Theme) => ({
    container: {
        marginTop: "10px",
        bgcolor: "#ffffff",
        position: "relative",
        width: "100%",
        marginBottom: "30px",
    },
}));

const videoChatStyle = makeStyles((theme: Theme) => ({
    container: {
        boxSizing: "border-box",
        marginTop: "10px",
        backgroundColor: "#ffffff",
        width: "100%",
        marginBottom: "0px",
        bottom: "10px",
        [theme.breakpoints.down("sm")]: {
            marginTop: "10px",
            backgroundColor: "#ffffff",
            position: "fixed",
            width: "calc(100% - 32px)",
            marginBottom: "0px",
            bottom: "10px"
        }
    },
}));

const MessageForm = (
    {
        handleSubmit = (val) => {
        }, disabled, handleAddMedia, userTyping, startTyping, endTyping, isVet, isVideo = false
    }) => {
    const {enqueueSnackbar} = useSnackbar();
    const [text, setText] = useState("");
    const [file, setFile] = useState(null);
    const [typingTimeout, setTypingTimeout] = useState(null);
    const fileRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [fileToConfirm, setFileToConfirm] = useState<any>("");
    const [fileLoaded, setFileLoaded] = useState(false);

    const classes = useStyle();
    const vetClasses = vetStyle();
    const videoClasses = videoChatStyle();

    const handleChange = (e) => {
        setText(e.target.value);
        startTyping();
        clearTimeout(typingTimeout);
        setTypingTimeout(setTimeout(function () {
            endTyping();
        }, 2000));
    };
    const handleClickSubmit = () => {
        if (text.length > 0) {
            handleSubmit(text);
            setText("");
        }
    };
    const handleOnKeyPress = (e) => {
        if (e.key === "Enter" && text.length > 0) {
            handleSubmit(text);
            setText("");
        }
    };
    const handleFileChange = (e) => {
        if (fileRef?.current.files[0].type.includes("image"))
        {
            const {files} = fileRef.current;
            const item = files[0];
            setFileToConfirm(item);
            // handleAddMedia(item);
            setFileLoaded(true);
            setShowModal(true);
        }
        else {
            enqueueSnackbar("Chat does not support sending videos. Please reach out to Customer Support if you would like to send a video", {
                variant: "error",
                autoHideDuration: 4000
            });
        }
    };

    const handleCancelAdd = (e) => {
        setFileLoaded(false);
        setFileToConfirm(null);
        fileRef.current.value = "";
        // handleAddMedia(item);
        setShowModal(false);
    };

    const handleFileConfirm = () => {
        handleAddMedia(fileToConfirm).then(res => {
            setFileLoaded(false);
            setFileToConfirm("");
            setShowModal(false);
        });
    };
    return (
        <Box className={isVet ? vetClasses.container : isVideo ? videoClasses.container : classes.container}>
            {userTyping && (
                <div style={{marginBottom: "5px"}}>
                    <Typography style={{width: "100%", marginLeft: "15%"}}>
                        {`... ${userTyping} is typing`}
                    </Typography>
                </div>
            )}
            <Grid container spacing={1} justify="flex-start" alignItems="center">
                <Grid item xs={3} sm={isVet ? 3 : 2}>
                    <Button
                        fullWidth
                        style={{textAlign: "center", height: 57}}
                        variant="contained"
                        component="label">
                        Upload Image
                        <input
                            onChange={handleFileChange}
                            type="file"
                            value={file}
                            disabled={disabled}
                            ref={fileRef}
                            style={{display: "none"}}
                        />
                    </Button>
                </Grid>
                <Grid item xs={6} sm={isVet ? 7 : isVideo ? 8 : 6}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        multiline={true}
                        InputProps={{style: {minHeight: "46px", backgroundColor: colorWhite}}}
                        onChange={handleChange}
                        onKeyPress={handleOnKeyPress}
                        placeholder="Type messages here"
                        value={text}
                        disabled={disabled}
                    />
                </Grid>
                <Grid item xs={3} sm={2}>
                    <Button fullWidth size="large" style={{height: 57}} variant="outlined" color="primary"
                        onClick={handleClickSubmit} disabled={disabled || text.length === 0}>
                        Send
                    </Button>
                </Grid>
            </Grid>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={showModal}
                onClose={() => setShowModal(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={showModal}>
                    <div className={classes.paper}>
                        <Typography variant="h2" gutterBottom>
                            Confirm Upload
                        </Typography>
                        {fileLoaded &&
                        <img src={URL.createObjectURL(fileToConfirm)} style={{maxHeight: "400px", maxWidth: "300px"}}/>
                        }
                        <Grid container justify="center" align-Items="space-between">
                            <Button
                                variant="outlined"
                                color="secondary"
                                className={classes.button}
                                onClick={handleCancelAdd}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={handleFileConfirm}
                            >
                                Confirm
                            </Button>
                        </Grid>
                    </div>
                </Fade>
            </Modal>
        </Box>
    );
};

export default MessageForm;
